import { Component, DoCheck, HostListener, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';

declare var $: any;
@Component({
  standalone: false,
  selector: 'app-assessment-form',
  templateUrl: './assessment-form.component.html',
  styleUrls: ['./assessment-form.component.css']
})
export class AssessmentFormComponent implements OnInit {
  tabView: any = 'Questionnaire';
  action: any = 'view';
  marks: any = '1';
  programList: any = [];
  assessmentForm: FormGroup;
  viewQustionairelist: boolean = true;
  viewQuestion: boolean = false;
  QusetionArrData: any = [];
  IsSubmittedAddQuestionnaire: any = 'false';
  assessmentArrData: any = [];
  public formDummyData = [
    {
      QuestionText: '',
      QuestionTextES: '',
      QuestionTextFR: '',
      'QuestionType': 'text',
      option: ['']
    },

  ];
  formDummyData3 = [
    {
      assessmentText: ''
    },
  ];

  public quesionform: FormGroup;
  public editquesionform: FormGroup;
  addAssessmentTitleForm: FormGroup;
  editAssessmentTitleForm: FormGroup;
  addAssessmentForm: FormGroup;
  editAssessmentForm: FormGroup;
  QuestionType: any = 'text';
  QuestionType1: any = 'text';
  viewAssessmentlist: boolean = true;
  queNumber: number = 0;
  questionTypeIndex: any;
  questionnaireList: any = [];
  panelOpenState = false;
  viewQuestionnaire: any = [];
  questionnaireId: any;
  queNumber1: any;
  questionTypeIndex1: any;
  editQuetionnaireId: any;
  QusetionArrData1: any = [];
  assessmentForm_List: any = [];
  assessmentId: any;
  viewAssessmentData: boolean = false;
  viewAsseessmentData: any;
  editAssessmentID: any;
  editAssessmentArrData: any = [];
  IsArrayPush: boolean = false;
  editAssessmentArrData2: any = [];
  itemPerPage: number = 10;
  currentPage: number = 1;
  total: number = 0;
  total1: number = 0;
  submitted: boolean = false;
  constructor(public service: MainService, private fb: FormBuilder, private activatedroute: ActivatedRoute,
    private router: Router) {
    this.quesionform = fb.group({
      'QueArr': fb.array([])
    });
    this.editquesionform = fb.group({
      'QueArr1': fb.array([])
    });
    this.assessmentForm = new FormGroup({
      programValue: new FormControl('')
    });
    this.addAssessmentForm = fb.group({
      assessmentText: [''],
      // marks: [''],
      'QueArr3': fb.array([]),
      remarks: fb.array([])
    });
    this.editAssessmentForm = fb.group({
      assessmentText: [''],
      // marks: [''],
      'QueArr4': fb.array([]),
      remarks: fb.array([])
    });

    this.activatedroute.queryParams.subscribe((res) => {
      if (Object.keys(res).length != 0) {
        let paramdaTa = JSON.parse(res.value);
        this.tabView = paramdaTa.tabView;
        this.action = paramdaTa.acion;
        this.assessmentListApi(this.currentPage);
      }


    })

    this.addAssessmentTitleForm = new FormGroup({
      "addassessmentTitle": new FormControl('', Validators.required),
      "addassessmentTitleFR": new FormControl(''),
      "addassessmentTitleES": new FormControl(''),
      "addAssessmentProgramValue": new FormControl('', Validators.required)
    });
    this.editAssessmentTitleForm = new FormGroup({
      "addassessmentTitle": new FormControl('', Validators.required),
      "addassessmentTitleFR": new FormControl(''),
      "addassessmentTitleES": new FormControl(''),
      "addAssessmentProgramValue": new FormControl('', Validators.required)
    });

  }

  ngOnInit() {
    if (this.formDummyData) {
      this.formDummyData.forEach(QueArr => {
        this.addUser(QueArr, '');
      });
    } else {
      this.addUser('', '');
    }
    if (this.formDummyData3) {
      this.formDummyData3.forEach(QueArr3 => {
        this.addUser3(QueArr3, '');
      });
    } else {
      this.addUser3('', '');
    }

    this.addRemark3();
    this.QusetionArrData = [];
    this.viewProgramList();
    this.questionnaireListApi(this.currentPage);
  }

  // program list api inntegration 
  viewProgramList() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.programList, 1).subscribe((res) => {
      this.service.hideSpinner();

      if (res.responseCode == 200) {
        this.programList = res.result;
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }

  addUser(QueArr?: any, i?: any) {
    this.queNumber = this.queNumber + 1;
    let fg = this.fb.group({
      'QuestionText': [QueArr ? QueArr.QuestionText : '', Validators.compose([Validators.required])],
      'QuestionTextES': [QueArr ? QueArr.QuestionTextES : ''],
      'QuestionTextFR': [QueArr ? QueArr.QuestionTextFR : ''],
      'QuestionType': [QueArr ? QueArr.QuestionType : '', Validators.compose([Validators.required])],
      'options': this.fb.array([]),
    });
    (<FormArray>this.quesionform.get('QueArr')).push(fg);
    let userIndex = (<FormArray>this.quesionform.get('QueArr')).length - 1;
    if (!QueArr) {
      this.addoption(userIndex);
    }
    else {
      QueArr.option.forEach((option: any) => {
        this.addoption(userIndex, option);
      });
    }
  }

  addUser3(QueArr?: any, i?: any) {
    // this.queNumber1 =this.queNumber1+1;
    let fg = this.fb.group({
      'assessmentText': [QueArr ? QueArr.assessmentText : '', Validators.compose([Validators.required])],
      'assessmentTextFR': [QueArr ? QueArr.assessmentText : ''],
      'assessmentTextES': [QueArr ? QueArr.assessmentText : ''],
      // 'marks': [QueArr ? QueArr.marks : '', Validators.compose([Validators.required])]
    });
    (<FormArray>this.addAssessmentForm.get('QueArr3')).push(fg);
  }

  addRemark3() {
    let fg = this.fb.group({
      'remark': ['', Validators.compose([Validators.required])],
      'remarkFR': [''],
      'remarkES': [''],
    });
    (<FormArray>this.addAssessmentForm.get('remarks')).push(fg);
  }

  addoption(userIndex: number, data?: any) {
    let fg = this.fb.group({
      'option': [data ? data : '', Validators.compose([Validators.required])],
    });
    (<FormArray>(<FormGroup>(<FormArray>this.quesionform.controls['QueArr']).controls[userIndex]).controls['options']).push(fg);

  }

  deleteOption(userIndex: number, index: number) {
    (<FormArray>(<FormGroup>(<FormArray>this.quesionform.controls['QueArr'])
      .controls[userIndex]).controls['options']).removeAt(index);
  }
  deleteOption1(userIndex: number, index: number) {
    (<FormArray>(<FormGroup>(<FormArray>this.editquesionform.controls['QueArr1'])
      .controls[userIndex]).controls['options1']).removeAt(index);
  }

  deleteUser(index: number) {
    (<FormArray>this.quesionform.get('QueArr')).removeAt(index);
  }
  deleteUser1(index: number) {
    (<FormArray>this.editquesionform.get('QueArr1')).removeAt(index);
  }
  deleteUser3(index: number) {
    (<FormArray>this.addAssessmentForm.get('QueArr3')).removeAt(index);
  }
  deleteRemark3(index: number) {
    (<FormArray>this.addAssessmentForm.get('remarks')).removeAt(index);
  }

  // @HostListener('click', ['$event'])
  qustionTypeChange(type: any, index: number) {
    this.QuestionType = type;
    this.questionTypeIndex = index;

  }

  qustionTypeChange1(type: any, index: number) {
    this.QuestionType1 = type;
    this.questionTypeIndex1 = index;

  }

  addQuestionnaire(IsSubmittedAddQuestionnaire: string) {
    if (IsSubmittedAddQuestionnaire == 'true') {
      this.IsSubmittedAddQuestionnaire = 'true';
      this.submitted = true;
      if (this.assessmentForm.value.programValue == '') {
        if (this.tabView == 'Questionnaire' && this.action == 'add') {
          this.service.warningToast('Please select your program');
          return
        }

        this.QusetionArrData = [];
      }
      this.quesionform.value.QueArr.forEach((element: any) => {
        if (this.tabView == 'Questionnaire' && this.action == 'add') {
          if (element.quesType == '') {
            this.service.warningToast('Please select the question type');
            return
          }
          this.QusetionArrData = [];
        }
        if ((element.quesType == 'checkbox') && this.quesionform.invalid) {
          this.service.warningToast('Please fill the all details');
          return
        }
        if (element.QuestionText == '' || element.QuestionTextES == '' || element.QuestionTextFR == '') {
          if (this.tabView == 'Questionnaire' && this.action == 'add') {
            this.service.warningToast('Please type your question');
            return
          }
          this.QusetionArrData = [];
        }
      });
      if (this.quesionform.value.QueArr.length > 0) {
        this.quesionform.value.QueArr.forEach((ele: any, index: number) => {
          if (this.QusetionArrData.length >= 0) {
            ele['QuestionNumber'] = index + 1;
            this.QusetionArrData.push(ele);
          }
        });
      } else {
        this.QusetionArrData = this.quesionform.value.QueArr[0];
      }
      if ((this.assessmentForm.value.programValue != '')) {
        const data = {
          programId: this.assessmentForm.value.programValue,
          Questions: this.QusetionArrData
        }
        this.service.showSpinner();
        this.service.postApi(ApiUrls.addQuestionnaire, data, 1).subscribe((res) => {
          this.service.hideSpinner();
          if (res.responseCode === 200) {
            this.tabView = "Questionnaire";
            this.IsSubmittedAddQuestionnaire = 'false';
            this.assessmentForm.value.programValue = '';
            this.action = "view";
            this.QusetionArrData = [];
            this.service.successToast(res.responseMessage);
            this.quesionform.reset();
            this.questionnaireListApi(this.currentPage);
          }
          else {
            this.QusetionArrData = [];
            this.IsSubmittedAddQuestionnaire = 'false';
            this.quesionform.reset();
            this.quesionform.value.QuestionType = '';
            this.service.errorToast(res.responseMessage)
          }

        }, err => {
          this.service.hideSpinner();
          this.service.errorToast(err.responseMessage)
        })
      }
    }



  }


  editQuestionnaireApi() {
    if (this.assessmentForm.value.programValue == '') {
      this.service.warningToast('Please select your program');
      this.QusetionArrData = [];
    }
    this.editquesionform.value.QueArr.forEach((element: any) => {
      if (element.quesType == '') {
        this.QusetionArrData = [];
        this.service.warningToast('Please select the question type');
        return;
      }
      if (element.QuestionText == '') {
        this.QusetionArrData = [];
        this.service.warningToast('Please type your question');
        return
      }
    });
    if (this.editquesionform.value.QueArr.length > 0) {
      this.editquesionform.value.QueArr.forEach((ele: any, index: number) => {
        if (this.QusetionArrData.length >= 0) {
          ele['QuestionNumber'] = index + 1;
          this.QusetionArrData.push(ele);
        }
      });
    } else {
      this.QusetionArrData = this.editquesionform.value.QueArr[0];
    }
  }


  // add Assessment api integration 

  addAssessmentApi() {

    if (this.addAssessmentTitleForm.value.addAssessmentProgramValue == '') {
      if (this.tabView == 'Assessments' && this.action == 'add') {
        this.service.warningToast('Please select your program');
        return
      }
      this.assessmentArrData = [];
    }
    this.addAssessmentForm.value.QueArr3.forEach((element: any) => {
      if (element.assessmentText == '') {
        this.assessmentArrData = [];
        if (this.tabView == 'Assessments' && this.action == 'add') {
          this.service.warningToast('Please type your question');
        }
        return
      }
    });
    if (this.addAssessmentForm.value.QueArr3.length > 0) {
      this.addAssessmentForm.value.QueArr3.forEach((ele: any, index: number) => {
        if (this.assessmentArrData.length >= 0) {
          ele['QuestionText'] = ele['assessmentText'];
          delete ele['assessmentText'];
          ele['QuestionTextFR'] = ele['assessmentTextFR'];
          delete ele['assessmentTextFR'];
          ele['QuestionTextES'] = ele['assessmentTextES'];
          delete ele['assessmentTextES'];
          ele['QuestionNumber'] = index + 1;
          ele['QuestionType'] = 'YESNO';
          ele.marks = 1;
          this.assessmentArrData.push(ele);
        }
      });
    } else {
      this.assessmentArrData = this.addAssessmentForm.value.QueArr3[0];
    }
    let remarkArrData: string[] = [], remarkArrDataFR: string[] = [], remarkArrDataES: string[] = [];

    this.addAssessmentForm.value.remarks.forEach((element: any) => {
      if (element['remark'].toString().trim() !== '') {
        remarkArrData.push(element['remark']);
        if (element['remarkFR'] !== undefined && element['remarkFR'] !== null) {
          remarkArrDataFR.push(element['remarkFR']);
        }
        if (element['remarkES'] !== undefined && element['remarkES'] !== null) {
          remarkArrDataES.push(element['remarkES']);
        }
      }
    });

    if (this.addAssessmentTitleForm.value.addAssessmentProgramValue != '' && this.addAssessmentForm.valid) {
      if (this.addAssessmentTitleForm.value.addassessmentTitle == '') {
        this.assessmentArrData = []
        this.service.errorToast('Title is required');
        return
      }
      let data: any = {
        programId: this.addAssessmentTitleForm.value.addAssessmentProgramValue,
        title: this.addAssessmentTitleForm.value.addassessmentTitle,
        Questions: this.assessmentArrData,
        remarks: remarkArrData
      }

      if (this.addAssessmentTitleForm.value.addassessmentTitleFR !== undefined && this.addAssessmentTitleForm.value.addassessmentTitleFR !== null) {
        data["titleFR"] = this.addAssessmentTitleForm.value.addassessmentTitleFR;
      }

      if (this.addAssessmentTitleForm.value.addassessmentTitleES !== undefined && this.addAssessmentTitleForm.value.addassessmentTitleES !== null) {
        data["titleES"] = this.addAssessmentTitleForm.value.addassessmentTitleES;
      }

      if (remarkArrDataFR !== undefined && remarkArrDataFR !== null && remarkArrDataFR.length > 0) {
        data["remarksFR"] = remarkArrDataFR;
      }

      if (remarkArrDataES !== undefined && remarkArrDataES !== null && remarkArrDataES.length > 0) {
        data["remarksES"] = remarkArrDataES;
      }

      this.service.showSpinner();
      this.service.postApi(ApiUrls.addAssessment_Form, data, 1).subscribe((res) => {
        this.service.hideSpinner();
        if (res.responseCode === 200) {
          this.tabView = "Assessments";
          this.action = "view";
          this.assessmentArrData = [];
          this.assessmentListApi(this.currentPage);
          this.service.successToast(res.responseMessage);
          this.addAssessmentForm.reset();
          this.addAssessmentTitleForm.reset();


          // this.questionnaireListApi();
        }
        else {
          this.assessmentArrData = [];
          this.addAssessmentForm.reset();
          this.addAssessmentTitleForm.reset();
          this.service.errorToast(res.responseMessage)
        }

      }, err => {
        this.service.hideSpinner();
        this.service.errorToast(err.responseMessage)
      })
    } else {
      this.service.errorToast('Fill the all details')
    }
  }


  viewTab(tab: string, action: string) {
    this.tabView = tab;
    this.action = action;
    this.viewQustionairelist = true;
    this.viewQuestion = false;
    if (this.tabView == 'Questionnaire' && this.action == 'edit') {
      this.editQuetionnaire(this.editQuetionnaireId);
    }
    if (this.tabView == 'Assessments' && this.action == 'view') {
      this.assessmentListApi(this.currentPage);
    }
    this.addQuestionnaire(this.IsSubmittedAddQuestionnaire);
  }

  // To get questionnaireList api integration 

  questionnaireListApi(page: number) {
    this.currentPage = page
    this.service.getApi(ApiUrls.questionnaireList + `?pageNumber=${this.currentPage}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.questionnaireList = res.result;
        this.total1 = res.paginationData.total
      }
    })
  }

  // To get assessmentListApi api integration 

  assessmentListApi(page: number) {
    this.currentPage = page
    this.service.getApi(ApiUrls.assessmentForm_List + `?pageNumber=${this.currentPage}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.assessmentForm_List = res.result;
        this.viewAssessmentlist = true;
        this.total = res.paginationData.total
      }
    })
  }


  // editQuetionnaire api integrtion

  editQuetionnaire(id: any) {
    this.editQuetionnaireId = id;
    //  this.tabView = 'Questionnaire';
    //  this.action = 'edit';
    this.router.navigate(['edit-question/' + id])
    //  this.viewQuestionaire(id);

  }

  editAssessment(id: any) {
    // this.eId = id ;
    // this.tabView = 'Assessments';
    // this.action = 'edit';
    this.router.navigate(['edit-assessment/' + id])
    // this.editViewAssessment(id);
  }



  // TO view particular quiestionnaire
  get QueArr1(): FormArray {
    return this.editquesionform.get('QueArr1') as FormArray;
  }

  // To view particular question api integration

  viewQuestionaire(id: any) {
    this.service.getApi(ApiUrls.viewQuestionnaire + `?questionnaireId=${id}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.viewQuestion = true;
        this.viewQustionairelist = false;
        this.viewQuestionnaire = res.result.Questions;

        this.viewQuestionnaire.forEach((ele: any) => {
          let options: any = [];
          ele.options.forEach((element: any) => {
            options.push({ "_id": element._id, "option": element.option })

          });
          let fg = this.fb.group({
            'QuestionText1': ele.QuestionText,
            'QuestionType1': ele.QuestionType,
            'options1': this.fb.array([options])
          });
          (<FormArray>this.editquesionform.get('QueArr1')).push(fg);
        });

      }
    }, err => {
      this.service.errorToast(err.responseMessage)
    })
  }

  // TO view particular assessment api integration
  viewAssessment(id: any) {
    this.service.getApi(ApiUrls.assessmentForm_view + `?formId=${id}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.viewAssessmentData = true;
        this.viewAssessmentlist = false;
        this.viewAsseessmentData = res.result
        this.programList.forEach((ele: any) => {
          if (this.viewAsseessmentData.programId == ele._id) {
            this.viewAsseessmentData['programTitle'] = ele.title;
          }
        });
        this.editAssessmentTitleForm.patchValue({
          addassessmentTitle: this.viewAsseessmentData.title,
          addassessmentTitleFR: this.viewAsseessmentData.titleFR,
          addassessmentTitleES: this.viewAsseessmentData.titleES,
          addAssessmentProgramValue: this.viewAsseessmentData.programId
        })
        //  this.viewQuestionnaire = res.result.Questions;

        this.viewAsseessmentData.Questions.forEach((ele: any) => {
          let fg = this.fb.group({
            'assessmentText': ele.QuestionText
          });
          (<FormArray>this.editAssessmentForm.get('QueArr4')).push(fg);
        });
        this.viewAsseessmentData.remarks.forEach((ele: any) => {
          let fgRemark = this.fb.group({
            'remark': ele
          });
          (<FormArray>this.editAssessmentForm.get('remarks')).push(fgRemark);

        });

      }
    }, err => {
      this.service.errorToast(err.responseMessage)
    })
  }

  changeMark(mark: any) {
    this.marks = mark;
  }

  deleteUserModal(id: any) {
    this.questionnaireId = id;
    $('#deleteQuestion').modal('show')
  }

  deleteAssessmentModal(id: any) {
    this.assessmentId = id;
    $('#deleteAssessment').modal('show')
  }

  // delete questionnaire api integration

  deleteQuestionApi() {
    const data = {
      questionnaireId: this.questionnaireId,
      status: 'DELETE'
    }
    this.service.postApi(ApiUrls.actionPerform_questionnaire, data, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        $('#deleteQuestion').modal('hide')
        this.service.successToast(res.responseMessage);
        this.questionnaireListApi(this.currentPage);

      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    })
  }

  // delete assessment api integration

  deleteAssessmentApi() {
    const data = {
      formId: this.assessmentId,
      status: "DELETE"
    }
    this.service.postApi(ApiUrls.actionPerform_assessmentForm, data, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        $('#deleteAssessment').modal('hide')
        this.service.successToast(res.responseMessage);
        this.assessmentListApi(this.currentPage);

      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    })
  }


}
